import React, { Component, Fragment } from 'react';
import { ArcaDate } from '../../../code/Types/ArcaDate';
import { ArcaHttpWalkplan } from '../../../code/ArcaHttpWalkplan';
import { Table } from 'reactstrap';
import { StatusBar } from '../StatusBar';
import { Link } from 'react-router-dom';
import { Phone } from '../ReactIcons/Phone';
import { ArcaSecurity } from '../../../code/ArcaSecurity';

export class OwnerSummaryPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            today: new ArcaDate(new Date()),
            referenceDate: new ArcaDate(new Date()),
            weekPlan: null,
            statusText: null,
            isError: false,
            LoadingText: 'Panel is loading...'
        };
    }

    componentDidMount() {
        ArcaHttpWalkplan.GetOwnerCalendarAsync(this.props.ownerId,
            this.state.today,
            (plan => this.setState({ weekPlan: plan }))/*.bind(this)*/,
            (status => {
                if (status === 404)
                    this.setState({
                        statusText: 'No bookings found',
                        LoadingText: null,
                        isError: false
                    })
                else
                    this.setState({
                        statusText: 'Error retrieving plans',
                        LoadingText: null,
                        isError: true
                    })
            })/*.bind(this)*/
        );
    }

    gotPlan(plan) {
        this.setState({ weekPlan: plan });
    }

    render() {
        var lastDate = null;
        return (
            <div>
                <h1>Your bookings for the next 7 days</h1>
        
                <StatusBar isError={this.state.isError} message={this.state.statusText} />
                {this.state.weekPlan
                    ? <Table className='table table-striped' aria-labelledby="tabelLabel">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Activity</th>
                                <th>Session</th>
                                {ArcaSecurity.IsAdmin
                                    ? <th>Walker</th>
                                    : null}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.weekPlan.map((slot, key) =>
                                <Fragment key={key}>
                                    <tr style={slot.Date.IsSameDate(this.state.today)
                                        ? { background: '#00ACEE' }
                                        : null}>

                                        {lastDate !== slot.Date.DayAndMonthPretty && (lastDate = slot.Date.DayAndMonthPretty)
                                            ? <td colSpan='4' >
                                                <h5>
                                                    {slot.Date.DayAndMonthPretty}
                                                    {slot.Date.IsSameDate(this.state.today)
                                                        ? ' - Today'
                                                        : null}
                                                </h5>
                                            </td>
                                            : null}
                                    </tr>
                                    <tr style={slot.Date.IsSameDate(this.state.today)
                                        ? { background: '#81CEEA' }
                                        : null}>

                                        <td>{slot.Name}</td>
                                        <td>{slot.Session}</td>
                                        <td>{slot.ActivityType}</td>

                                        {ArcaSecurity.IsAdmin
                                            ? <td
                                                style={slot.WalkerName
                                                    ? null
                                                    : { background: '#F2C287' }
                                                }>
                                                {slot.WalkerName
                                                    ? <Fragment>
                                                        <Phone
                                                            Phone={slot.Mobile}
                                                            text={' - Call:'} />
                                                        <Link
                                                            style={{ 'cursor': 'pointer' }}
                                                            to={"/PersonView?id=" + slot.AssignedWalkerId}>
                                                            {slot.WalkerName}
                                                        </Link>
                                                    </Fragment>
                                                    : 'Walker not yet confirmed'}
                                                </td>
                                            : null}
                                    </tr>
                                </Fragment>
                            )}
                        </tbody>
                    </Table>
                    : <h6>{this.state.LoadingText}</h6>}

            </div>
        );
    }
}